import { ReactComponent } from "./minus-fill.svg";

interface Props {
  style?: React.CSSProperties;
}

const MinusFillIcon: React.FC<Props> = (props) => <ReactComponent {...props} />;

export default MinusFillIcon;
